module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_ac_down-b78ef392e20f1ba638c9e9ef0e068b8c.png";